import React from 'react'
import PropTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Link } from 'react-router-dom'
import './styles.css'

class ArticuloItem extends React.Component {
    constructor(props) {
        super(props)
        this.props.getImgArticulo(this.props.itemArticulo.idArticulo)
        this.state = {
            imageError: false
        };
    }

    handleImageError = () => {
        this.setState({ imageError: true });
    };
    render() {
        const { listaImagenesArticulos } = this.props.itemArticulo;
        const imagenArticulo = listaImagenesArticulos && listaImagenesArticulos.length > 0 && listaImagenesArticulos[0].imagen;
        return (
            this.props.isGenerico
                ?
                <div className='itemArticuloContainer' onClick={this.props.handleclick.bind(this, this.props.isGenerico, this.props.idSuperRubro, this.props.itemArticulo.idRubro, this.props.itemArticulo.idArticulo)}>
                    <div className='cardImgContainer'>
                        {imagenArticulo && !this.state.imageError ? (
                            <div className='imageArticuloGenerico'>
                                <img
                                    src={`data:image/ief;base64,${imagenArticulo}`}
                                    onError={this.handleImageError}
                                />
                            </div>
                        ) : (
                            <div className='imageDefault'>
                                <div>
                                    <img src={require('../../images/logoLogin.png')} alt="Producto sin foto" />
                                    <div>Producto sin foto</div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='nombreArticulo'>
                        {this.props.itemArticulo.nombre}
                    </div>
                    <div className='rowButton row'>
                        <div className='btnsCantidad'></div>
                        <div className='containerPrecios'>
                            <span className={`precioLista ${this.props.itemArticulo.precioPromocional ? 'precioTachado' : ''}`}>
                                ${this.props.itemArticulo.precioLista}
                            </span>
                            {this.props.itemArticulo.precioPromocional ?
                                <span className='precioClientazo'>
                                    ${this.props.itemArticulo.precioPromocional}
                                </span>
                                :
                                <span className='precioClientazo'>

                                </span>
                            }
                        </div>
                    </div>
                </div>
                :
                <div className='itemArticuloTextilContainer'
                    onClick={this.props.handleclick.bind(this, this.props.isGenerico, this.props.idSuperRubro, this.props.itemArticulo.idRubro, this.props.itemArticulo.idArticulo)}>

                    {this.props.itemArticulo.listaImagenesArticulos !== undefined && this.props.itemArticulo.listaImagenesArticulos.length > 0 && this.props.itemArticulo.listaImagenesArticulos[0].imagen !== null
                        ?
                        <img src={`data:image/ief;base64,${this.props.itemArticulo.listaImagenesArticulos[0].imagen}`} className='imagenArticulo' />
                        :
                        <div>
                            <CircularProgress />
                            <div className='nombreItem'>{this.props.itemArticulo.nombre}</div>
                        </div>
                    }
                </div>
        )
    }
}

ArticuloItem.propTypes = {
    itemArticulo: PropTypes.object.isRequired,
    idSuperRubro: PropTypes.object.isRequired,
    isGenerico: PropTypes.object.isRequired,
    getImgArticulo: PropTypes.func.isRequired,
    handleclick: PropTypes.func.isRequired
}

ArticuloItem.defaultProps = {
}

export default ArticuloItem